export default __webpack_public_path__ + "locales/hy-AM/ChangePhoneDialog.json?hash=528926f3e973618d2df9f848d41a0cf1";